// extracted by css-extract-rspack-plugin
export default {"UserFieldGroup":"CvFJ_"};